<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card title="Grupos de Materias por competencias" code-toggler>
        <p>Antes de crear un grupo favor de verificar el Kardex del alumno</p>
        <p>{{cuatrimestre_actual[0].nombre}} {{cuatrimestre_actual[0].idAgno}}</p><br>
        <v-select class="float-left" style="width: 300px;" label="nombre" v-model="carreras_select" :options="carreras"></v-select>

        <div class="">
                <vs-popup style="" class="holamundo"  title="Nuevo Grupo:" :active.sync="popupActive">
                    <p>Materia
                        <v-select label="nombre" v-model="ngrupo_materia" :options="materias_carrera"></v-select>
                    </p>
                    <p>Profesor
                        <v-select label="ncompleto" v-model="ngrupo_profesor" :options="profesores_carrera"></v-select>
                    </p>
                    <p style="margin: 10px;">
                        <vs-button  class="float-right"  @click="guardar_nuevo_grupo_competencias()">Agregar</vs-button>
                    </p>
                </vs-popup>

            </div>

            <div class="mt-5">

                        <div style="text-align: right;">
                            <p>
                                <vs-button class="" style="margin: 3px;"  @click="nuevogruposigiente()">Nuevo Grupo</vs-button>
                            </p>
                        </div>
                        <div class="flex-centered">

                            <vs-table search stripe :data="grupos_competencias">

                                <template slot="thead">

                                    <vs-th>Materia</vs-th>
                                    <vs-th>Grupo</vs-th>
                                    <vs-th>Profesor</vs-th>
                                    <vs-th>Alumnos</vs-th>
                                <!--    <vs-th>Acciones</vs-th> -->
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].nombre}}
                                        </vs-td>
                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].idPeriodo}}CO
                                        </vs-td>

                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].nombres}} {{data[indextr].apellidPterno}} {{data[indextr].apellidoMaterno}}
                                        </vs-td>
                                        <vs-td style="text-align: left;" :data="data[indextr].id">
                                            <vs-button class=""  @click="ver_alumnos(data[indextr])">Ver</vs-button>
                                        </vs-td>
                                        <!--   <vs-td style="text-align: center;" :data="data[indextr].id">
                                               <vs-button radius color="success" type="gradient" icon-pack="feather" icon="icon-edit" @click="editar_grupo(data[indextr])"></vs-button>
                                                  <vs-button radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"  @click="openConfirm(data[indextr].id_unico)"></vs-button>
                                        </vs-td>  -->
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>


            </div>

    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'


    import Table from "../ui-elements/table/Table";

    import DragItDude from "vue-drag-it-dude";
    import Button from "../components/vuesax/button/Button";

    export default {
        data() {
            return {

                carrera: localStorage.getItem('id_carrera'),
                cuatrimestre_actual: [{ nombre: "", idAgno: "" }],


                alumno_detalle: [],
                grupos: [],
                materias_a_duplicar: [],
                popupActive: false,
                grupos_competencias: [],
                carreras: [],
                carreras_select: [],
                value1: '',
                duplicar_activo: 1,
                nuevo_grupo_siguiente: [],
                materias_carrera: [],
                profesores_carrera: [],

                ngrupo_materia : [],
                ngrupo_profesor : [],
                ngrupo_cupo : 30,
                ngrupo_cuatrimestre : '',
                ngrupo_grupo : '',


                ngrupo_grupo_select :  [
                    { text: 'A' },
                    { text: 'B' },
                    { text: 'C' },
                    { text: 'D' },
                    { text: 'E' },
                    { text: 'F' },
                ]

            }
        },
        components: {
            Button,
            Table,
            'v-select': vSelect,
            FormWizard,
            TabContent,
            DragItDude
        },
        created() {

            this.$vs.loading();
            this.carrera =  localStorage.getItem('id_carrera');
            this.getCuatrimestreActual();

          //  this.getGruposCompetencias();
         //   this.getCarreras();


        },
        mounted(){
        },
        watch: {
            carreras_select: function () {
                this.carrera = this.carreras_select.id
                this.getGruposCompetencias();

            }

        },
        methods: {

            getCuatrimestreActual(){
                this.$http.get("cuatrimestre_actual").then(
                    response => {
                        // console.log(response.data)
                        this.cuatrimestre_actual = response.data.cuatrimestre_actual;
                        //console.log(this.kardex);
                        this.getCarreras();
                        this.getGruposCompetencias();
                        this.getMateriasCarrera();
                        this.getProfesoresCarrera();
                        //
                        //

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },


            guardar_nuevo_grupo_competencias(){
                this.popupActive = false
                this.$http.post('nuevo_grupo_competencias', {
                    ngrupo_materia: this.ngrupo_materia.id,
                    ngrupo_profesor: this.ngrupo_profesor.id,
                    carrera: this.carrera,
                    idAgno: this.cuatrimestre_actual[0].idAgno,
                    idPeriodo: this.cuatrimestre_actual[0].idPeriodo
                })
                    .then(response => {
                            this.popupActive=false

                            // console.log(response.data)
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Grupo editado',
                                text: 'Se ha guardado el grupo correctamente'
                            })
                            this.getGruposCompetencias()
                    },
                error => {
                        //error;
                    this.StepError(error);
                    });



            },
            getMateriasCarrera(){
                this.$http.get("materias_carrera/" + this.carrera).then(
                    response => {
                        // console.log(response.data)
                        this.materias_carrera = response.data.materias;
                        //console.log(this.kardex);
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getProfesoresCarrera(){
                this.$http.get("profesores_carrera/" + this.carrera).then(
                    response => {
                        // console.log(response.data)
                        this.profesores_carrera = response.data.profesores;
                        //console.log(this.kardex);
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            nuevogruposigiente(){
                this.popupActive=true
            },
            openConfirm(matricula) {
                localStorage.setItem("grupo_a_quitar", matricula)
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirmar`,
                    text: '¿Seguro que desea quitar el grupo?.',
                    accept: this.acceptAlert
                })
            },
            acceptAlert() {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Grupo quitado',
                    text: ''
                })
                this.$http.get("quitar_grupo_siguiente/" +  localStorage.getItem("grupo_a_quitar")).then(
                    response => {
                        this.getGrupos()
                    },
                    error => {
                        this.StepError(error);
                    }
                );

            },
            getGruposCompetencias() {
              /*

               this.$http.get("grupos_a_duplicar/" + this.carrera).then(

                    response => {
                        // console.log(response.data)
                        this.grupos = response.data.grupos;
                        //console.log(this.kardex);
                    },
                    error => {
                        this.StepError(error);
                    }
                );

               */

                this.$http.get("grupos_competencias_periodo/" + this.carrera + "/" + this.cuatrimestre_actual[0].idAgno + "/" + this.cuatrimestre_actual[0].idPeriodo).then(
                    response => {
                        // console.log(response.data)
                        this.grupos_competencias = response.data.grupos;
                        //console.log(this.kardex);
                        this.$vs.loading.close();

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            validar_nuevos_grupos(){
                this.duplicar_activo = 0
                this.$http.post('enviar_grupos', {
                    grupos: this.grupos

                })
                    .then(function (response) {

                        alert("Se han importado correctamente")
                        location.reload()

                    })
                    .catch(function (error) {
                        alert("Se han duplicado correctamente")
                        //    this.getGrupos()
                        location.reload()
                    });
            },
            getCarreras() {
                this.$http.get("carreras").then(
                    response => {
                        // console.log(response.data)
                        this.carreras = response.data.carreras;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
                this.$http.get("carrera_id/" + this.carrera).then(
                    response => {
                        // console.log(response.data)
                        this.carreras_select = response.data.carrera[0];
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            ver_alumnos(grupo){
             //   alert(grupo.id_grupo)
                localStorage.setItem('idGrupo', grupo.id_grupo)
                localStorage.setItem('desc_grupo', grupo.nombre + " (" + grupo.idPeriodo +"CO)")
                this.$router.push('/directores/detallegrupo')
            }
        },
    }
</script>
<style>
    body{
        font-family: arial;
        margin: 0px; /* for IE6 / IE7 */
    }


    /* drag container */
    #main_container{
        margin: auto;
        width: 700px;
    }
    /* container for the left table */
    #main_container #left{
        width: 100px;
        height: 320px;
        float: left;
        margin-right: 20px;
    }
    /* container for the main table and message line below */
    #main_container #right{
        width: 675px;
        padding-left: auto;
        padding-right: 0px;
        /* align div to the right */
        margin-left: auto;
    }


    /* drag objects (DIV inside table cells) */
    .drag{
        cursor: move;
        margin: auto;
        z-index: 10;
        background-color: white;
        text-align: center;
        font-size: 10pt; /* needed for cloned object */
        opacity: 0.7;
        filter: alpha(opacity=70);
        /* without width, IE6/7 will not apply filter/opacity to the element ?! */
        width: 87px;
        height: 20px;
        line-height: 20px;
    }


    /* tables */
    div#drag table {
        background-color: #eee;
        border-collapse: collapse;
    }
    /* timetable */
    div#drag #table2 {
        /* align table to the right */
        margin-left: auto;
    }


    /* table cells */
    div#drag td{
        border-style: solid;
        border-width: 1px;
        border-color: white;
        height: 32px;
        text-align: center;
        font-size: 10pt;
        padding: 2px;
    }
    /* overwrite border settings for left tables */
    /* set all borders to 0px except border-bottom */
    div#drag #table1 td{
        border-width: 0px 0px 1px 0px;
    }


    /* green objects */
    .green {
        border: 2px solid #499B33;
        height: auto;
        width: auto;
    }


    /* blank cells (upper left corner) */
    .blank {
        background-color: white;
    }


    /* background color for lunch */
    .lunch {
        color: #665;
        background-color: #f8eeee;
    }


    /* trash cell */
    .trash {
        color: white;
        background-color: #6386BD;
    }


    /* message line */
    #message{
        color: white;
        background-color: #aaa;
        text-align: center;
        margin-top: 10px;
    }


    /* dark cells (first column and table header) */
    .dark{
        color: #444;
        background-color: #e0e0e0;
    }

    .button_container{
        padding-top: 10px;
        text-align: right;
    }

    /* "Save" button */
    .button_container input{
        background-color: #6A93D4;
        color: white;
        border-width: 1px;
        width: 40px;
        padding: 0px;
    }


    /* append here cloned object before placing to the target table cell */
    #obj_new{
        height: 32px;
        width: 100px;
    }
</style>


